import {Aggregation, ElasticFilter, ElasticSort} from '../rest-api.model'

export class ElasticQuery {
  // field
  index: string
  query: string
  maxResults: number
  offset: number
  sorts: ElasticSort[]
  filters: ElasticFilter[]
  aggregations: Aggregation[]

  // constructor
  constructor(index: string, query: string, maxResults: number) {
    this.index = index
    this.query = query
    this.maxResults = maxResults
    this.filters = []
    this.aggregations = []
  }

  addAggregation(agg: Aggregation) {
    this.aggregations.push(agg)
  }

  addFilter(filter: ElasticFilter) {
    this.filters.push(filter)
  }

  clearFilter() {
    this.filters.length = 0
  }

  // function
  toJson(): string {
    return JSON.stringify(this)
  }
}
